var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { scriptService } from "../services/ScriptService";
import { resolveUid } from "../model/Utils";
import { uiBusService } from "../services/UIBusService";
export class ScriptUIBus {
    static subscribe(uid, pattern, callback) {
        if (!scriptService.context) {
            throw new Error("script context is not defined");
        }
        if (!scriptService.context.currentRoom) {
            throw new Error("currentRoom is not defined");
        }
        uid = resolveUid(uid);
        uiBusService.subscribe(scriptService.context.currentRoom.roomUID, uid, pattern, callback);
    }
    static unsubscribe(uid, pattern, callback) {
        if (!scriptService.context) {
            throw new Error("script context is not defined");
        }
        if (!scriptService.context.currentRoom) {
            throw new Error("currentRoom is not defined");
        }
        uid = resolveUid(uid);
        uiBusService.unsubscribe(scriptService.context.currentRoom.roomUID, uid, pattern, callback);
    }
    static send(pattern, ...params) {
        if (!scriptService.context)
            return;
        uiBusService.send(scriptService.context.currentRoomModelUID, pattern, ...params);
    }
    static ask(pattern, ...params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!scriptService.context)
                return;
            return yield uiBusService.ask(scriptService.context.currentRoomModelUID, pattern, ...params);
        });
    }
}
